import { ComponentPropsWithoutRef, ComponentRef, FC, Ref } from 'react';
import classNames from 'classnames';
import { Toast as RadixToast } from 'radix-ui';

import { ToastPosition } from '../model/ToastPosition';
import { useToastQueue } from '../model/useToastQueue';

import ToastItem from './ToastItem/ToastItem';
import styles from './ToastViewport.module.css';

export type ToastViewportProps = {
  /** Угол/край вьюпорта, к которому привязана очередь тостов. По умолчанию — bottomRight. */
  position?: ToastPosition;
  /** Класс для контейнера очереди. */
  viewportClassName?: string;
  /** Класс для каждого отдельного тоста в этом вьюпорте. */
  toastClassName?: string;
  /** Ref на контейнер очереди тостов. */
  ref?: Ref<ComponentRef<typeof RadixToast.Viewport>>;
} & Omit<ComponentPropsWithoutRef<typeof RadixToast.Viewport>, 'className'>;

/** Рендерит очередь тостов, собранную через `toast.*`. Монтировать один раз на приложение. */
const ToastViewport: FC<ToastViewportProps> = ({
  position = 'bottomRight',
  viewportClassName,
  toastClassName,
  ref,
  label = 'Уведомления ({hotkey})',
  ...rest
}) => {
  const queue = useToastQueue();

  return (
    <RadixToast.Provider>
      {queue.map((item) => (
        <ToastItem
          key={item.id}
          item={item}
          className={toastClassName}
        />
      ))}

      <RadixToast.Viewport
        ref={ref}
        label={label}
        {...rest}
        className={classNames(styles.viewport, styles[position], viewportClassName)}
      />
    </RadixToast.Provider>
  );
};

export default ToastViewport;
